import { PoliceTax } from './../../../entities/policeTax';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EventEmitter } from 'events';
import { DialogData } from 'src/app/entities/dialogData';
import { AvisService } from 'src/app/services/avis.service';
import { CategoryService } from 'src/app/services/category.service';
import { SharedService } from 'src/app/services/sharedService';
import { TaxPayerService } from 'src/app/services/taxPayer.service';
import { UserService } from 'src/app/services/user.service';
import { DialogCommunicator } from '../dialog-communicator';
import { TaxNameService } from 'src/app/services/taxName.service';

@Component({
  selector: 'gov-police-tax-dialog',
  templateUrl: './police-tax-dialog.component.html',
  styleUrls: ['./police-tax-dialog.component.css']
})
export class PoliceTaxDialogComponent extends DialogCommunicator implements OnInit {
  text: string;
  emitter: EventEmitter;
  policeTax: any;
  currentUser: any;
  taxNames: any[] = [];
  nonVehicleTaxNames: any[] = [];
  vehicleTaxNames: any[] = [];
  licensePlateOptions: any[] = [];
  filteredLicensePlateOptions: any[] = []; 
  existingVehicleSelected = false;
  selectedVehicle: any = null;
  constructor(
    public dialogRef: MatDialogRef<PoliceTaxDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public sharedService: SharedService,
    public taxPayerService: TaxPayerService,
    public categoryService: CategoryService,
    public avisService: AvisService,
    public userService: UserService,
    public confirmationDialog: MatDialog,
    private taxNameService: TaxNameService
  ) {
    super(dialogRef, sharedService);
    this.setConfirmationDialog(this.confirmationDialog);
  }

  ngOnInit() {
    this.userService.getCurrentUser().subscribe(user => {
      this.policeTax = new PoliceTax();
      this.policeTax.date = new Date();
      this.policeTax['class'] = 'POLICE-TAX';
      this.policeTax.policeTaxType = null;
      this.policeTax.taxName = null;
      this.policeTax.paymentLocation = '';
      this.policeTax.vehicleMake = '';
      this.policeTax.vehicleModel = '';
      this.policeTax.licensePlate = '';
      this.policeTax.chassisNumber = '';
      this.policeTax.municipalRegistry = '';
      this.setEntity(this.policeTax);
      this.currentUser = user;
    });

    this.taxNameService.getList('tax-name').subscribe((res: any) => {
      const records = res.records || res || [];
      this.taxNames = records;
      this.nonVehicleTaxNames = records.filter(t => t.nonVehiclePoliceTax === true);
      this.vehicleTaxNames    = records.filter(t => t.vehiclePoliceTax === true);
    });

    const tin = this.data && this.data['tin'] ? this.data['tin'] : null;
    if (tin) {
      this.taxPayerService.getVehiclesByTin(tin).subscribe(vehicles => {
        this.licensePlateOptions = (vehicles || [])
          .filter(v => v.licensePlate)
          .map(v => ({ ...v }))
          .sort((a, b) => a.licensePlate.localeCompare(b.licensePlate));

        this.filteredLicensePlateOptions = [...this.licensePlateOptions];
      });
    }
  }

  onLicenseInput(value: string) {
    if (this.selectedVehicle && value !== this.selectedVehicle.licensePlate) {
      this.existingVehicleSelected = false;
      this.selectedVehicle = null;
    }
    if (!value) {
      this.filteredLicensePlateOptions = [...this.licensePlateOptions];
      this.clearVehicleDetailsFromPlate();
      return;
    }
    const valLower = value.toLowerCase();
    this.filteredLicensePlateOptions = this.licensePlateOptions.filter(v =>
      v.licensePlate.toLowerCase().includes(valLower)
    );
    const exact = this.licensePlateOptions.find(
      v => v.licensePlate.toLowerCase() === valLower
    );
    if (exact) {
      this.applyVehicle(exact);
    }else{
      this.clearVehicleDetailsFromPlate();
    }
  }

  selectChangeTaxNames = (event: any) => {
    this.policeTax['taxName'] = event.data[0];
  };

  public objectComparisonFunction = function (option, value): boolean {
    if (value) return option === value;
    return false;
  };

  isSaveDisabled() {
    if (this.updateRequested) return true;
    if (!this.policeTax?.policeTaxType) return true;
    if (this.policeTax.policeTaxType === 'nonVehicle') {
      return !this.policeTax.taxName;
    }
    if (this.policeTax.policeTaxType === 'vehicle') {
      return !this.policeTax.taxName || !this.policeTax.licensePlate;
    }
    return false;
  }

  onLicenseOptionSelected(plate: string) {
    const vehicle = this.licensePlateOptions.find(v => v.licensePlate === plate);
    if (vehicle) {
      this.applyVehicle(vehicle);
    }
  }

  private applyVehicle(vehicle: any) {
    this.selectedVehicle = vehicle;
    this.existingVehicleSelected = true;
    this.policeTax.licensePlate      = vehicle.licensePlate      || this.policeTax.licensePlate;
    this.policeTax.vehicleMake       = vehicle.vehicleMake       || '';
    this.policeTax.vehicleModel      = vehicle.vehicleModel      || '';
    this.policeTax.chassisNumber     = vehicle.chassisNumber     || '';
    this.policeTax.municipalRegistry = vehicle.municipalRegistry || '';
    if (vehicle.taxName) {
      this.policeTax.taxName = vehicle.taxName;
    }
    if (vehicle.paymentLocation) {
      this.policeTax.paymentLocation = vehicle.paymentLocation;
    }
  }

  convertDate = (dateStr) => {
    if (isNaN(Date.parse(dateStr))) {
      return '';
    }
    const date = new Date(dateStr);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  private clearVehicleDetailsFromPlate() {
    this.existingVehicleSelected = false;
    this.selectedVehicle = null;
  
    this.policeTax.vehicleMake       = '';
    this.policeTax.vehicleModel      = '';
    this.policeTax.chassisNumber     = '';
    this.policeTax.municipalRegistry = '';
    this.policeTax.paymentLocation   = '';
  }
  
}
